export const configIconsPolyline = (tipo_element, bool) => {
  const listIconsItems = {
    PUENTE: {
      path: "M 5 0 A 5 5 0 5 0 -5 0 A 5 5 0 5 0 5 0 Z",
      strokeColor: "#FF0000",
      fillColor: bool ? "transparent" : "#FF0000",
      fillOpacity: 1,
      strokeWeight: 2,
      scale: 0.5,
    },
    FUSIBLES: {
      path: "M 4.5 -10 L 4.5 10 L -4.5 10 L -4.5 -10 Z",
      strokeColor: "#FF0000",
      fillColor: bool ? "transparent" : "#FF0000",
      fillOpacity: 1,
      strokeWeight: 2,
      scale: 0.5,
    },
    INTERRUPTOR: {
      path: "M 4.5 -10 L 4.5 10 L -4.5 10 L -4.5 -10 Z",
      strokeColor: "#FFF",
      fillColor: bool ? "transparent" : "#FFF",
      fillOpacity: 1,
      strokeWeight: 2,
      scale: 0.5,
    },
    ["INTERRUPTOR AUTOMATICO MT"]: {
      path: "M 4.5 -10 L 4.5 10 L -4.5 10 L -4.5 -10 Z",
      strokeColor: "#F8AECA",
      fillColor: bool ? "transparent" : "#F8AECA",
      fillOpacity: 1,
      strokeWeight: 2,
      scale: 0.5,
    },
    SECCIONADOR: {
      path: "M 4.5 -10 L 4.5 10 L -4.5 10 L -4.5 -10 Z",
      strokeColor: "#3F47CC",
      fillColor: bool ? "transparent" : "#3F47CC",
      fillOpacity: 1,
      strokeWeight: 2,
      scale: 0.5,
    },
  };

  return listIconsItems[tipo_element];
};

